import ColorButton from 'components/Widget/Button/ColorButton';
import { IconType } from 'components/Icon';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import forge from 'apis/forge';
import { setPlanPricingModalVisible, setSidebarVisible } from 'redux/mode/actions';
import { RootReducer } from 'redux/reducers';
import { selectIsMobile } from 'redux/mode/reducers';
import { selectIsGuest } from 'redux/db/reducers';
import * as routes from 'routes';
import * as S from './styles';

const NewButton = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { isMobile, isGuest } = useSelector(
		(r: RootReducer) => ({
			isMobile: selectIsMobile(r.mode),
			isGuest: selectIsGuest(r.db),
		}),
		shallowEqual
	);
	const [isCreatingProject, setIsCreatingProject] = useState(false);

	const onNewProject = () => {
		if (isGuest) {
			dispatch(setPlanPricingModalVisible(true));
			return;
		}
		navigate('/');
		if (isMobile) {
			dispatch(setSidebarVisible(false));
		}
	};

	const onNewDesignSystem = () => {
		if (isGuest) {
			dispatch(setPlanPricingModalVisible(true));
			return;
		}
		navigate(routes.createDesignSystem());
		if (isMobile) {
			dispatch(setSidebarVisible(false));
		}
	};

	const onCreateEmptyProject = async () => {
		if (isGuest) {
			dispatch(setPlanPricingModalVisible(true));
			return;
		}
		if (isCreatingProject) return;
		setIsCreatingProject(true);
		try {
			const res = await forge.createScene.withToast()({
				title: 'My Project',
			});
			navigate(routes.scene(res.sceneId, 'My Project'));
			if (isMobile) {
				dispatch(setSidebarVisible(false));
			}
		} catch (e) {
			// Error handling is done by withToast()
		} finally {
			setIsCreatingProject(false);
		}
	};

	const onProjectCreatorInNewTab = () => {
		if (isGuest) {
			dispatch(setPlanPricingModalVisible(true));
			return;
		}
		window.open(routes.home(), '_blank', 'noopener,noreferrer');
	};

	if (isMobile) {
		return (
			<S.Base>
				<ColorButton label="New Project" icon={IconType.ADD} onClick={onNewProject} fullWidth data-testid="new-project-button" />
			</S.Base>
		);
	}

	// Desktop with DS enabled: render split button with dropdown
	return (
		<S.Base>
			<ColorButton
				label="New Project"
				onClick={onNewProject}
				fullWidth
				data-testid="new-project-button"
				menuItems={[
					{
						label: 'New Design System',
						icon: IconType.COMPONENT,
						onClick: onNewDesignSystem,
					},
					{
						label: isCreatingProject ? 'Creating...' : 'New Blank Project',
						icon: IconType.FILE,
						onClick: onCreateEmptyProject,
						disabled: isCreatingProject,
					},
					{
						label: 'Project Creator in New Tab',
						icon: IconType.OPEN_EXTERNAL,
						onClick: onProjectCreatorInNewTab,
					},
				]}
			/>
		</S.Base>
	);
};

export default NewButton;
